import { prop, pipe } from 'ramda';
import { createSelector } from 'reselect';

import { IRootState } from '../../../../store/root.types';
import { GiftType } from '../../constants/giftTypes.constants';
import { MessageType } from '../../../../store/types/Message.types';

const pathToDataState = (state: IRootState) => state.recipient.data;

export const getIsGiftInfoLoaded = pipe(pathToDataState, state => state.isLoaded);
export const getIsLoading = pipe(pathToDataState, state => state.isLoading);

export const getGiftState = pipe(pathToDataState, state => state.gift);
export const getGiftMessage = pipe(getGiftState, state => state.message);
export const getGiftHashId = pipe(getGiftState, state => state.hashId);
export const getGiftCustomizing = pipe(getGiftState, state => state.customizations);
export const getGiftProduct = pipe(getGiftState, prop('product'));
export const getGiftGl = pipe(getGiftState, state => state.giftLanguage || 'gift');
export const getGiftCalendarProvider = pipe(getGiftState, state => state.calendarProvider);

export const getGiftProductCountryId = pipe(getGiftProduct, prop('countryId'));

export const getIsCode = pipe(getGiftState, gift => gift.type === GiftType.code);
export const getIsGift = pipe(getGiftState, gift => gift.type === GiftType.gift);

export const getActionsState = pipe(getGiftState, state => state.actions);
export const getCanBeExchanged = pipe(getActionsState, state => state.exchange);
export const getCanBeAccepted = pipe(getActionsState, state => state.accept);
export const getCanBeDonated = pipe(getActionsState, state => state.donate);

export const getGiftCountryId = pipe(getGiftState, state => state.countryId);
export const getIsGiftClaimed = pipe(getGiftState, state => state.isClaimed);
export const getReverseReason = pipe(getGiftState, state => state.reverseReason);

export const getShouldResetFlow = pipe(pathToDataState, state => state.shouldResetFlow);

export const getCanExchangeAndDonate = createSelector(
  getCanBeExchanged,
  getCanBeDonated,
  (exchange, donate) => exchange && donate,
);

export const getCanExchangeOrDonate = createSelector(
  getCanBeExchanged,
  getCanBeDonated,
  (exchange, donate) => exchange || donate,
);

export const getIsDonationProduct = pipe(getGiftProduct, product => product.isDonation);

export const getMessageType = pipe(getGiftState, ({ customizations, message }) =>
  customizations.messageImageUrl || customizations.mobileMessageImageUrl ? MessageType.image : message.type,
);

export const getIsRedirectRequired = pipe(getGiftCustomizing, customization => !!customization.redirectUrl);
